import { useEffect, useState } from "react";
import Input from "../../blocks/Input";
import { useForm } from "../../hooks/useForm";
import "./payment-form.css";
import { ajax } from "../../scripts/helper";
import utils from "../../scripts/utils";
import { useSnackbar } from "notistack";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs, { Dayjs } from "dayjs";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useLocation, useNavigate } from "react-router-dom";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { Autocomplete, Switch, TextField } from "@mui/material";

const CashForm = ({ edit }) => {
  dayjs.extend(timezone);
  dayjs.extend(utc);
  const { enqueueSnackbar } = useSnackbar();
  const [validity, setValidity] = useState(dayjs().add(1, "day"));
  const navigate = useNavigate();
  const { state } = useLocation();
  // const [autoBooking, setAutoBooking] = useState(false)
  const [auto, setAuto] = useState(false);
  const [autoBooking, setAutoBooking] = useState(false);
  const [detail, setDetail] = useState({});
  const [currencies, setCurrencies] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(JSON.parse(window.localStorage.getItem("userInfo"))?.office?.currency);
  const [hasReference, setHasReference] = useState(true);

  const [inputFields, handleChange, setInputFields] = useForm({
    value: {
      name: "value",
      type: "text",
      value: "",
      placeholder: "1,000",
      decimal: true,
    },
    person: {
      name: "person",
      type: "text",
      value: "",
      placeholder: "محمد احمدی",
    },
    phone: {
      name: "phone",
      type: "text",
      value: "",
      placeholder: "912*******",
    },
    email: {
      name: "email",
      type: "text",
      value: "",
      placeholder: "me@example.com",
    },
    pnr: {
      name: "pnr",
      type: "text",
      value: "",
      placeholder: "CNJJUT",
    },
    service: {
      name: "service",
      type: "select",
      value: "",
      items: [],
      selected: null,
    },
    currency: {
      name: "currency",
      type: "select",
      value: "",
      items: [],
      selected: null,
    },
    paymentGateway: {
      name: "pgw",
      value: "",
      type: "select",
      selected: null,
      items: [],
    },
    comment: {
      name: "comment",
      value: "",
      type: "textarea",
      placeholder: "Write comment (Optional)",
    },
  });

  const [type, setType] = useState();

  const fillData = () => {
    setInputFields({
      ...inputFields,
      value: {
        ...inputFields.value,
        value: state.data.amount.toLocaleString(),
      },
      pnr: {
        ...inputFields.pnr,
        value: state.data.reference,
      },
    });
  };

  const handleSelectDropDown = (service) => {
    setInputFields({
      ...inputFields,
      service: {
        ...inputFields.service,
        selected: service.id,
        value: service.name,
      },
    });
  };
  const handleCurrencyDropDown = (currency) => {
    setInputFields({
      ...inputFields,
      currency: {
        ...inputFields.currency,
        selected: currency.id,
        value: currency.name,
      },
    });
  };

  const handlePGWDropDown = (pgw) => {
    setInputFields({
      ...inputFields,
      paymentGateway: {
        ...inputFields.paymentGateway,
        selected: pgw.id,
        value: pgw.name,
      },
    });
  };

  const getProductsAndAccounts = async () => {
    const res = await ajax({
      method: "GET",
      url: utils.urls.accessibleProduct,
      snackbar: enqueueSnackbar,
      hasToken: true,
    });

    if (!res) return;

    const serviceItems = res.data.map((service) => {
      return {
        label: service.name,
        id: service.id,
        data: service,
      };
    });

    const response = await ajax({
      method: "GET",
      url: utils.urls.visiblePaymentGateway,
      snackbar: enqueueSnackbar,
      hasToken: true,
    });

    if (!response) return;
    const posAccounts = response.data.filter(
      (account) => account.type === "OFFLINE"
    );
    const accounts = posAccounts.map((acc) => {
      return {
        label: acc.name,
        id: acc.id,
        data: acc,
      };
    });
    const cashPgwId = localStorage.getItem("cash-pgw-id");
    let cashPgwSelected;
    if (cashPgwId) cashPgwSelected = accounts.find((a) => a.id == cashPgwId);
    else cashPgwSelected = accounts[0];

    setCurrencies([getOffice.office.currency])
    setSelectedCurrency(getOffice.office.currency)
    if (state.type === "pnr") {
      setAuto(true);
      setInputFields({
        ...inputFields,
        paymentGateway: {
          ...inputFields.paymentGateway,
          selected: cashPgwSelected?.id,
          items: accounts,
          value: cashPgwSelected?.label,
        },
        service: {
          ...inputFields.service,
          items: serviceItems,
          selected: serviceItems[0].id,
          value: serviceItems[0].label,
        },
        currency: {
          ...inputFields.currency,
          items: currencies,
          selected: getOffice.office.currency.id,
          value: getOffice.office.currency.code,
        },
        value: {
          ...inputFields.value,
          value: state.data.amount.toLocaleString(),
        },
        pnr: {
          ...inputFields.pnr,
          value: state.data.reference,
        },
        phone: {
          ...inputFields.phone,
          value: state.data?.mobile,
        },
        email: {
          ...inputFields.email,
          value: state.data?.email,
        },
        person: {
          ...inputFields.person,
          value: state.data?.primaryContact,
        },
      });
    } else {
      setInputFields({
        ...inputFields,
        paymentGateway: {
          ...inputFields.paymentGateway,
          selected: cashPgwSelected?.id,
          items: accounts,
          value: cashPgwSelected?.label,
        },
        currency: {
          ...inputFields.currency,
          items: currencies,
          selected: getOffice.office.currency.id,
          value: getOffice.office.currency.code,
        },
        service: {
          ...inputFields.service,
          items: serviceItems,
          selected: serviceItems[0].id,
          value: serviceItems[0].label,
        },
      });
    }
  };

  const getTransactiondetail = async (id) => {
    const serviceRes = await ajax({
      method: "GET",
      url: utils.urls.accessibleProduct,
      snackbar: enqueueSnackbar,
      hasToken: true,
    });

    if (!serviceRes) return;

    const serviceItems = serviceRes.data.map((service) => {
      return {
        label: service.name,
        id: service.id,
        data: service,
      };
    });

    const res = await ajax({
      method: "GET",
      url: utils.urls.linkDetail(id),
      hasToken: true,
      snackbar: enqueueSnackbar,
    });

    if (!res) return;

    setDetail(res.data);

    const response = await ajax({
      method: "GET",
      url: utils.urls.visiblePaymentGateway,
      snackbar: enqueueSnackbar,
      hasToken: true,
    });

    if (!response) return;
    const cashAccounts = response.data.filter(
      (account) => account.type === "OFFLINE"
    );
    const accounts = cashAccounts.map((acc) => {
      return {
        label: acc.name,
        id: acc.id,
        data: acc,
      };
    });
    setValidity(dayjs(res.data.validity));
    setHasReference(res.data.reference? true: false )
    setCurrencies([res.data.currency])
    setSelectedCurrency(res.data.currency)
    setInputFields({
      ...inputFields,
      value: {
        ...inputFields.value,
        value: res.data.amount.toLocaleString(),
      },
      pnr: {
        ...inputFields.pnr,
        value: res.data.reference,
      },
      person: {
        ...inputFields.person,
        value: res.data.primaryContact,
      },
      phone: {
        ...inputFields.phone,
        value: res.data.mobile,
      },
      email: {
        ...inputFields.email,
        value: res.data.email,
      },
      service: {
        ...inputFields.service,
        items: serviceItems,
        selected: res.data.product.id,
        value: res.data.product.name,
      },
      currency: {
        ...inputFields.currency,
        items: currencies,
        selected: getOffice.office.currency.id,
        value: getOffice.office.currency.code,
      },
      paymentGateway: {
        ...inputFields.paymentGateway,
        selected: res.data.account.id,
        value: res.data.account.name,
        items: accounts,
      },
      comment: {
        ...inputFields.comment,
        value: res.data.comments,
      },
    });

    setType("edit");
  };

  const fetchCurrency = async (input) => {

    const response = await ajax({
      method: 'GET',
      url: utils.urls.searchCurrency(input),
      hasToken: true,
      snackbar: enqueueSnackbar
    })
   setCurrencies(response.data) 
  }

  const fillDataFromCalculatorForm = async () => {
    console.log(
      state.data,
      "this is state from calculator form",
      inputFields.service.items,
      "test test test"
    );
    const res = await ajax({
      method: "GET",
      url: utils.urls.accessibleProduct,
      snackbar: enqueueSnackbar,
      hasToken: true,
    });

    if (!res) return;

    const serviceItems = res.data.map((service) => {
      return {
        label: service.name,
        id: service.id,
        data: service,
      };
    });

    const response = await ajax({
      method: "GET",
      url: utils.urls.visiblePaymentGateway,
      snackbar: enqueueSnackbar,
      hasToken: true,
    });

    if (!response) return;
    const IpgAccounts = response.data.filter(
      (account) => account.type === "OFFLINE"
    );
    const accounts = IpgAccounts.map((acc) => {
      return {
        label: acc.name,
        id: acc.id,
        data: acc,
      };
    });

    const index = serviceItems.findIndex((el) => el.label === "Baggage");

    const data = state.data;
    setInputFields({
      ...inputFields,
      value: {
        ...inputFields.value,
        value: data.payableAmount.value,
      },
      person: {
        ...inputFields.person,
        value: data.contact?.value,
      },
      phone: {
        ...inputFields.phone,
        value: data.mobile?.value,
      },
      email: {
        ...inputFields.email,
        value: data.email?.value,
      },
      pnr: {
        ...inputFields.pnr,
        value: data.pnr.value,
      },
      paymentGateway: {
        ...inputFields.paymentGateway,
        selected: accounts[0].id,
        items: accounts,
        value: accounts[0].label,
      },
      service: {
        ...inputFields.service,
        items: serviceItems,
        selected: serviceItems[index].id,
        value: serviceItems[index].label,
      },
    });
  };

  useEffect(() => {
    if (state && state.ref && state.ref === "calculator" && state.data) {
      fillDataFromCalculatorForm();
      return;
    }
    if (edit !== null) {
      getTransactiondetail(edit);
      return;
    } else {
      getProductsAndAccounts();
    }
  }, []);

  const createTransactionValidation = (data) => {
    let hasError = false;
    if (
      state?.type == "ref" &&
      (
        // !data.reference ||
        (data.reference && data.reference.trim().length === 0))
    ) {
      enqueueSnackbar("Reference is not correct", { variant: "error" });
      hasError = true;
    }
    if (
      !data.primaryContact ||
      !data.mobile ||
      !data.accountId ||
      !data.productId
    ) {
      enqueueSnackbar("Fill all star fields", { variant: "error" });
      hasError = true;
    }
    data.reference = data.reference?.toUpperCase();
    return hasError;
  };

  const createTransaction = async () => {
    const data = {
      accountId: inputFields.paymentGateway.selected,
      validity: validity.tz("Asia/Tehran").utc(true).toISOString(),
      productId: inputFields.service.selected,
      paymentType: "CASH",
      amount: parseInt(inputFields.value.value.replaceAll(",", "")),
      // "currencyId": getOffice.office.currency.id,
      currencyId: inputFields.currency.selected,
      autoAmount: auto,
      autoBooking: autoBooking,
      reference: hasReference ? inputFields.pnr.value : null,
      primaryContact: inputFields.person.value,
      mobile: inputFields.phone.value,
      comments: inputFields.comment.value,
      email: inputFields.email.value,
    };
    const hasError = createTransactionValidation(data);
    if (hasError) {
      return;
    }

    localStorage.setItem("cash-pgw-id", inputFields.paymentGateway.selected);
    const res = await ajax({
      method: "POST",
      hasToken: true,
      url: utils.urls.createTransaction,
      data,
      snackbar: enqueueSnackbar,
    });

    if (!res) return;

    navigate("/agent/payments", { replace: true, state: res.data });
  };

  const getOffice = JSON.parse(window.localStorage.getItem("userInfo"));

  const updateTransaction = async () => {
    const data = {
      accountId: inputFields.paymentGateway.selected,
      amount: parseInt(inputFields.value.value.replaceAll(",", "")),
      validity: validity.tz("Asia/Tehran").utc(true).toISOString(),
      productId: inputFields.service.selected,
      currencyId: inputFields.currency.selected,
      reference: hasReference ? inputFields.pnr.value : null,
      mobile: inputFields.phone.value,
      primaryContact: inputFields.person.value,
      email: inputFields.email.value,
      comments: inputFields.comment.value,
    };
    const hasError = createTransactionValidation(data);
    if (hasError) {
      return;
    }

    const res = await ajax({
      method: "PUT",
      url: utils.urls.updateLink(detail.id),
      hasToken: true,
      snackbar: enqueueSnackbar,
      data,
    });

    if (!res) return;

    navigate("/agent/payments", { replace: true, state: res.data });
  };

  const handleAutoBooking = (autoBooking) => {
    if (autoBooking) {
      setAutoBooking(false);
    }
    if (!autoBooking) {
      if (auto) {
        setAutoBooking(true);
      }
      if (!auto) {
        enqueueSnackbar("Auto booking can enable in auto amount mode", {
          variant: "error",
        });
      }
    }
  };

  const handelAuto = (auto) => {
    if (auto) {
      setAuto(false);
      setAutoBooking(false);
    }
    if (!auto) {
      if (state && state.data.amount) {
        setAuto(true);
        setInputFields({
          ...inputFields,
          value: {
            ...inputFields.value,
            value: state.data.amount.toLocaleString(),
          },
          pnr: {
            ...inputFields.pnr,
            value: state.data.reference,
          },
        });
      } else {
        enqueueSnackbar("PNR is not valid", { variant: "error" });
      }
    }
  };

  return (
    <div className="cash-form">
      <div className="form-container__header"> Complete link information</div>

      <div className="value">
        {((state && state.type === "pnr") || detail?.autoAmount) && (
          <div>
            <label>
              Auto Amount:{" "}
              <Switch
                color="primary"
                checked={auto}
                onChange={() => handelAuto(auto)}
              />
            </label>
            <div>
              <label>Auto Booking:</label>
              <Switch
                color="primary"
                checked={autoBooking}
                onChange={() => handleAutoBooking(autoBooking)}
              />
            </div>
          </div>
        )}
        <label>Amount*</label>
        <div className="value-container">
          <div className="value-input">
            <Input
              inputField={inputFields.value}
              onChange={handleChange}
              readOnly={type === "edit" || auto ? true : false}
            />
          </div>
          {/* <div className="value-currency">{ getOffice.office.currency.code}</div> */}
          <div className="value-currencyd">
            {/* <label>Product*</label> */}
            {/* <Input
              className="extra"
              inputField={inputFields.currency}
              onChange={handleChange}
              onClickDropdownItem={handleCurrencyDropDown}
            /> */}
        <Autocomplete
            readOnly={edit}
          sx={{ width: "100%" }}
          renderInput={(params) => <TextField {...params} />}
          getOptionLabel={(option) =>{
            return option ? option.code : ''}}
          options={currencies}
          autoComplete
          includeInputInList
          value={selectedCurrency}
          noOptionsText="No currency"
          onChange={(event, newValue) => {
            if(newValue){
            setSelectedCurrency(newValue)
            setInputFields({
              ...inputFields,
              currency: {
                ...inputFields.currency,
                selected: newValue.id,
                value: newValue.code
              }
            })}
          }}
          onInputChange={(event, newInputValue) => {
            if (newInputValue.trim())
              fetchCurrency(newInputValue)
          }}
          renderOption={(props, option) => <li {...props}>{option.code}</li>}

        />
          </div>
        </div>
      </div>

      <div className="form-container__inputs">
        <div className="row">
          <div className="officeId">
            <label>Product*</label>
            <Input
              className="extra"
              inputField={inputFields.service}
              onChange={handleChange}
              onClickDropdownItem={handleSelectDropDown}
            />
          </div>
          <div className="officeCode hasSwitch">
            <div className="first">
              <label>Reference</label>
              <Input
                className="extra"
                inputField={inputFields.pnr}
                onChange={handleChange}
                readOnly={auto ? true :!hasReference}
              />
            </div>
            <div
              className={`switch ${detail?.reference || auto ? "display-none" : ""}`}
            >
              <label>No reference</label>
              <Switch
                color="primary"
                checked={!hasReference}
                onChange={(e, checked) => {
                  setHasReference(!hasReference);
                  if (checked) {
                    setInputFields({
                      ...inputFields,
                      pnr: {
                        ...inputFields.pnr,
                        value: "",
                      },
                    });
                  }
                }}
              />
            </div>
          </div>
          {/* <div className="officeCode">
            <label>Reference</label>
            <Input
              className="extra"
              inputField={inputFields.pnr}
              onChange={handleChange}
              readOnly={auto ? true : false}
            />
          </div> */}
        </div>
        <div className="row">
          <div className="officeId">
            <label>Account*</label>
            <Input
              className="extra"
              inputField={inputFields.paymentGateway}
              onChange={handleChange}
              onClickDropdownItem={handlePGWDropDown}
            />
          </div>
          <div className="datePicker">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateTimePicker
                label="Expire date*"
                viewRenderers={{
                  hours: renderTimeViewClock,
                  minutes: renderTimeViewClock,
                  seconds: renderTimeViewClock,
                }}
                value={validity}
                onChange={(e) => setValidity(e)}
                ampm={false}
                format="YYYY-MM-DD HH:mm"
              />
            </LocalizationProvider>
          </div>
        </div>
        <div className="row">
          <div className="officeId">
            <label>Contact Person*</label>
            <Input
              className="extra"
              inputField={inputFields.person}
              onChange={handleChange}
            />
          </div>
          <div className="officeCode">
            <label>Mobile*</label>
            <Input
              className="extra"
              inputField={inputFields.phone}
              onChange={handleChange}
              onClickDropdownItem={handlePGWDropDown}
            />
          </div>
        </div>
        <div className="row">
          <div className="officeId">
            <label>Email</label>
            <Input
              className="extra"
              inputField={inputFields.email}
              onChange={handleChange}
            />
          </div>

          <div className="officeCode">
            <label>Comment</label>
            <Input
              className="extra"
              inputField={inputFields.comment}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

      {type !== "edit" && (
        <div className="btn-container">
          <button
            onClick={() => {
              navigate("/agent/payments", { replace: true });
            }}
            className="payment-btn-back"
          >
            Back
          </button>
          <button onClick={createTransaction} className="payment-btn">
            Create
          </button>
        </div>
      )}

      {type == "edit" && (
        <div className="btn-container">
          <button
            onClick={() => {
              navigate("/agent/payments", { replace: true });
            }}
            className="payment-btn-back"
          >
            Back
          </button>
          <button onClick={updateTransaction} className="payment-btn">
            Save
          </button>
        </div>
      )}
    </div>
  );
};

export default CashForm;
